<template>
  <vx-card v-show="isCardActiveLocal" :title="questionCardTitle">
    <div class="vx-row pb-3">
      <div class="vx-col w-full mb-2">
        <label>Title</label>
        <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required|max:128'" name="Title" v-model="questionData.title" />
        <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
      </div>
    </div>
    <div class="vx-row pb-3">
      <div class="vx-col w-full mb-2">
        <label>Question Text</label>
        <quill-editor v-model="questionData.questionText" :options="editorOption"  /> <!--  :options="editorOption" -->
      </div>
    </div>
    <div class="vx-row pb-3">
      <div class="vx-col w-1/2 mb-2">
        <label>Classification</label>
        <v-select class="style-chooser" placeholder="Select / Add Question Classification" taggable push-tags :options="questionClassifications" @option:created="addNewClassification" v-model="classificationDropdown"></v-select>
      </div>
    </div>
    <div v-show="sourceQuizGradeType == 'graded' ? true : false" >
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/6 w-1/3">
          <label>Score</label>
          <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'numeric'" name="Score" v-model="questionData.score" />
          <span class="text-danger text-sm" v-show="errors.has('Score')">{{ errors.first('Score') }}</span>
        </div>
      </div>
    </div>

    <vs-divider class="mb-6 pt-0">Question Image</vs-divider>

        <div class="vx-col w-1/3 mx-auto self-center filepondwidthforquizandquestions">
          <file-pond
            v-show="true"
            id="quiz-filepond"
            ref="questionPagePond"
            :server="uploadLocation"
            label-idle="Drop Question Image file here or <span class='filepond--label-action' text-decoration-color: #aaa>Browse</span>"
            accepted-file-types="image/*"
            :allow-multiple="false"
            allowPaste=false
            :instant-upload="true"
            @processfile="uploadCompleteQuestion"
            @removefile="fileRemovedQuestion"
          />
        </div>
        <div class="vx-row ">
          <div class="vx-col sm:w-2/3 w-full mb-2 mx-auto">
            <div v-show="questionData.imageUrl">
              <vs-table ref="imageUploadTable" single max-items="5" :data="uploadedImage">
                <template slot-scope="{data}">
                  <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
                    <vs-td style="width: 40px">
                      <img :src="file.url" width=30px class="product-img" />
                    </vs-td>                 
                    <vs-td>
                      <p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1)  }}</p>                     
                    </vs-td>
                    <vs-td>
                      <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="clearImageUrl"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>                      
          </div>
        </div> 

    <div class="vx-row pb-3">
      <div class="vx-col w-full">
        <vs-divider class="mb-6 pt-0">Choices</vs-divider>
      </div>
    </div>
    <div>
      <ul>
        <li v-for="(option, index) in questionData.quizQuestionOptions" :key="index">
          <div class="d-flex align-items-center pb-3">
            <div class="b-col w-full">
              <div class="mb-2  align-items-center " style="max-width: 100%; display:flex ;justify-content:center;">
                <label>{{option.optionNumber = index + 1}}.</label>
                <quill-editor v-model="option.optionText" style="width:80%; margin:0px 20px;"/>
                <div class="vx-col flex-1 mt-2" v-show="sourceQuizGradeType == 'graded' ? true : false" >
                  <vs-radio color="success" v-model="optionCorrectAnswer" :vs-value="option.optionNumber">Correct</vs-radio>
                </div>
                <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="deleteChoice(index)"></vs-button>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <vs-button ref="choicesAdd" class="w-full cursor-pointer mb-4" type="border" color="success" icon-pack="feather" icon="icon-plus" @click="addChoices"></vs-button>
    </div>
    <div>
      
    </div>

    <div class="vx-row">
      <vs-spacer></vs-spacer>
      <div class="vx-col">
        <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" ref="saveQuestionButton" :disabled="saveButtonDisabled" @click="saveEditQuestion">Save</vs-button>
        <vs-button color="danger" v-show="questionData.id" class="mr-5 mb-2 vs-con-loading__container" @click="deleteQuestion" ref="deleteQuestionButton">Delete</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="isCardActiveLocal = false">Cancel</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';
  import vSelect from 'vue-select'
  import QuillEditor from '../components/extra-components/quill-editor/QuillEditor.vue';

  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  export default {
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      questionSelected: {
        type: Object,
        required: false
      },
      sourceQuizId: {
        type: Number,
        required: false
      },
      sourceQuizGradeType: {
        type: String,
        required: false
      },
      numberOfQuestions: {
        type: Number,
        required: false
      },
      questionCardTitle: {
        type: String,
        required: false
      },
      questionClassifications: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        editorOption: {
          modules: {
            toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            ['clean']
          ]
          },
        },
        loadingColor:'#fff',
        isQuizListHidden: false,
        questionData: {
          id: 0,
          quizId: 0,
          questionClassificationId: 0,
          number: 0,
          title: "",
          questionText: "",
          allowMultipleAnswers: false,
          score: "",
          quizQuestionOptions: [],
          imageUrl: null,
        },
        optionCorrectAnswer: "",
        optionWithCorrectAnswer: {},
        classificationDropdown: 0,
        selectedQuiz: [],
        quizzes: [],
        uploadedImage: [],
        once:0,
        gradedQuiz: false,
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
      saveButtonDisabled: function() {
        var self = this;
        if(self.gradedQuiz){
          if(!self.questionData.score || self.questionData.score == 0){
            return true;
          }
        }

        if(this.questionData.quizQuestionOptions.filter(function(item){ return item.isCorrectAnswer }).length == 0)
          return true;

        return !(this.questionData.title && this.questionData.quizQuestionOptions.length != 0);
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          this.once = 0;
          if(this.$refs){
            this.$vs.loading.close(this.$refs.saveQuestionButton.$el);
          }
          var self = this;
          self.once = 0;
          self.$vs.loading.close(self.$refs.saveQuestionButton.$el);

          self.gradedQuiz = self.sourceQuizGradeType == 'graded' ? true : false
          if(self.questionSelected.id){
            self.questionData.id = self.questionSelected.id;
            self.questionData.quizId = self.sourceQuizId;
            self.questionData.number = self.questionSelected.number;
            self.questionData.title = self.questionSelected.title;
            self.questionData.questionText = self.questionSelected.questionText;
            self.questionData.score = self.questionSelected.score == 0 ? "" : self.questionSelected.score;
            self.questionData.quizQuestionOptions = self.questionSelected.quizQuestionOptions;
            self.classificationDropdown = self.questionClassifications.filter(function (item) { return item.value == self.questionSelected.questionClassificationId; })[0];

            self.questionData.imageUrl = self.questionSelected.imageUrl;

            if(self.questionData.imageUrl){
              self.uploadedImage = [];
              self.uploadedImage.push({
                url: self.questionData.imageUrl,        
              })
            }
            
            self.optionWithCorrectAnswer = self.questionData.quizQuestionOptions.filter(function(item){
              return item.isCorrectAnswer
            })[0];
            self.optionCorrectAnswer = self.optionWithCorrectAnswer.optionNumber;

          }else{
            self.initValues();
          }
        }
      }
    },
    methods: {
      saveData() {
        this.loadData();
      },
      saveEditQuestion() {
        this.once = this.once + 1;
        var self = this;
        self.showLoadingOnSaveQuestionButton();
        self.questionData.quizId = self.sourceQuizId;

        self.questionData.quizQuestionOptions.filter(function(item){
          item.isCorrectAnswer = item.optionNumber == self.optionCorrectAnswer;
        });

        self.questionData.score = isNaN(parseInt(self.questionData.score)) ? 0 : parseInt(self.questionData.score);

        if(self.questionSelected.number != null)
          self.questionData.number = self.questionSelected.number;
        else
          self.questionData.number = self.numberOfQuestions + 1;

        self.questionData.questionClassificationId = isNaN(parseInt(self.classificationDropdown ? self.classificationDropdown.value : self.classificationDropdown)) ? null : parseInt(self.classificationDropdown.value);
        
        
        if(self.once == 1){
          var onSuccess = response => {
          self.saveData();
          self.scrollToNavbar();
          self.isQuizListHidden = true;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.saveQuestionButton.$el);
        };
          self.$ajaxPost(self, "question/addeditquestion", self.questionData, onSuccess, onFinally);
        }
        else{
          self.$vs.loading.close(self.$refs.saveQuestionButton.$el);
          self.isQuizListHidden = true;
        }
      },
      deleteQuestion() {
        var self = this;
        self.showLoadingOnDeleteButton();

        var onSuccess = response => {
          self.saveData();
          self.scrollToNavbar();
          self.isQuizListHidden = true;
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteQuestionButton.$el);
        };

        self.$ajaxDelete(self, "Question/DeleteQuestion/" + self.questionData.id, onSuccess, onFinally);
      },
      initValues() {
        this.questionData.id = 0;
        this.questionData.number = 0;
        this.questionData.title = "";
        this.questionData.questionText = "";
        this.questionData.score = "";
        this.questionData.quizQuestionOptions = [];
        this.optionCorrectAnswer = "";
        this.questionData.number = 0;
        this.questionData.questionClassificationId = 0;
        this.questionData.imageUrl = null;
        this.classificationDropdown = 0;
        this.errors.clear();
        this.selectedQuiz = [];
        this.quizzes = [];
        this.uploadedImage = [];
        this.$refs.questionPagePond.removeFiles();
        this.gradedQuiz = false;
      },
      addChoices() {
        var self = this;
        if(self.questionData.quizQuestionOptions.length == 0){
          self.questionData.quizQuestionOptions.push({
            id: 0,
            quizQuestionId: self.questionData.id,
            optionText: '',
            isCorrectAnswer: true
          });
          self.optionCorrectAnswer = 1;
        }else{
          self.questionData.quizQuestionOptions.push({
            id: 0,
            quizQuestionId: self.questionData.id,
            optionText: '',
            isCorrectAnswer: false
          });
        }
        self.scrollToFooter();
      },
      deleteChoice(index) {
        this.questionData.quizQuestionOptions.splice(index,1)
      },
      addNewClassification(newClassification) {
        const self = this;
        self.$ajaxGet(self, "Question/AddClassification?name=" + newClassification.label, function(response){
          self.classificationDropdown = {value: response.data.value, label: response.data.text};
        });
      },
      showLoadingOnSaveQuestionButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveQuestionButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnQuestionsTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.questionTable.$el,
          scale: 1
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteQuestionButton.$el,
          scale: 0.45
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      loadData() {
        const self = this;

        var onSuccess = function (response) {
          self.quizzes = response.data;

          self.quizzes.forEach(element => {

            if(self.sourceQuizId == element.id){
              self.selectedQuiz = element;
            };            
          });

          self.$emit('saveData');
          self.$emit('handleSelectedQuiz', self.selectedQuiz);
          self.initValues();
        };
        var onFinally = function () {
          
        };

        self.$ajaxGet(self, "quiz/ListQuizzes", onSuccess, onFinally);
      },
      uploadCompleteQuestion(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url){
          this.uploadedImage = [];
          this.questionData.imageUrl = response.url;
          this.uploadedImage.push({
            url: response.url,        
          })
        }
      },
      fileRemovedQuestion(error, file) {
        this.questionData.imageUrl = null;
      },
      clearImageUrl() {
        this.uploadedImage = [];
        this.questionData.imageUrl = null;
      },
    },
    components: {
      quillEditor,
      'v-select': vSelect,
      FilePond,
    }
  }

</script>

<style lang="scss">
.numberinput{
  background: #ffffff;
  float: left;
}

#optionText_TextArea {
  width: 50%;
}

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-textarea {
  border: 0 solid #c2c6dc !important;
}
</style>
